import device from './device';
import Config from '../config';

export default function allowFlash() {
    return Config.flashEngine && Config.flashEngine.load && device.isFlashCapable();
}



// WEBPACK FOOTER //
// ./src/js/util/allow-flash.js